import { always, identity, ifElse, map, prop, propEq, reject } from 'ramda';

export const removeItemList = (element, elementList, searchBy = 'description') =>
	reject(propEq(searchBy, prop(searchBy, element)), elementList);

export const updateFactorList = (element, elementList, searchBy = 'name') =>
	map(
		ifElse(
			propEq(searchBy, element.name),
			always(element),
			identity,
		),
	)(elementList);

export const updateSubFactorsList = (element, elementList, searchBy = 'code') =>
	map(
		ifElse(
			propEq(searchBy, element.code),
			always(element),
			identity,
		),
	)(elementList);
export default {};



// WEBPACK FOOTER //
// ./src/modules/recruitment/utils/listElements.js